import { useQuery } from '@tanstack/react-query';
import { riskTriageReportApi } from '@/features/reports/api';
import { ApiError } from '@/shared/api';

export const riskTriageReportQueryKeys = {
  all: ['risk-triage-report'] as const,
  byYear: (year: number) => [...riskTriageReportQueryKeys.all, year] as const,
};

export function useRiskTriageReportQuery(
  year: number | null,
  options?: { classificationWorkflowReady?: boolean }
) {
  const wf = options?.classificationWorkflowReady;
  const enabled =
    (wf !== false) && year != null && Number.isFinite(year) && year > 0;

  return useQuery({
    queryKey: riskTriageReportQueryKeys.byYear(year ?? 0),
    queryFn: () => riskTriageReportApi.getReport(year!),
    enabled,
    retry: false,
  });
}

export function riskTriageReportErrorMessage(err: unknown): string {
  return err instanceof ApiError ? ApiError.getUserMessage(err) ?? err.message : 'Could not load risk triage report.';
}
